(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('MultichannelLinks', MultichannelLinks);

  MultichannelLinks.$inject = ['$resource'];

	 function MultichannelLinks ($resource) {
    return $resource(apiUrl + '/multichannel-links/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      paged: { url: apiUrl + '/multichannel-links/paged', method: 'GET', params: {}, isArray: false },
      create: { method: 'POST', params: {}, isArray: false },
      update: { method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      find: { method: 'GET', params: {}, isArray: false },
      findOne: { method: 'GET', params: {}, isArray: true },
      destroy: { method: 'DELETE', params: {}, isArray: false }
    });
  }
})();
